import React from 'react'
import { Box } from 'rebass'
import { Text } from 'rebass'
import { observer } from 'mobx-react'

// stores
import GameStore from 'App/stores/GameStore'

import PlayerName from 'App/components/playerName/PlayerName'

@observer
class TableNames extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
    }
  }
  render() {
    return (<>
        {/* Player Names */}
        {/* North position */}
        <Box
          sx={{
            position: 'absolute',
            bottom: 0,
            left: '50%',
            marginLeft: [-45, -60],
            display: GameStore.phase === 'auction' && (GameStore.bidTurn === GameStore.playerName[0]) ? 'none' : 'block',
            transform: ['translateY(-250px)', 'translateY(-315px)']
          }}
        >
          <PlayerName active={GameStore.tablePlayers.north.active}>{GameStore.tablePlayers.north.name}</PlayerName>
        </Box>

        {/* East Position */}
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: GameStore.dummyAbsolute === 'east' ? [-115, -45] : [-35, -45],
            // right: [20, 26], /* 26 is the height of the PlayerName container (20 for mobile) */
            mt: [-13, -13],
            transform: ['translateX(250px) rotate(-90deg)', 'translateX(315px) rotate(-90deg)'],
            display: GameStore.phase === 'auction' && (GameStore.bidTurn === GameStore.playerName[0]) ? 'none' : 'block'
          }}
        >
          <PlayerName active={GameStore.tablePlayers.east.active}>{GameStore.tablePlayers.east.name}</PlayerName>
          </Box>

        {/* South position */}
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: '50%',
            marginLeft: [-45, -60],
            display: GameStore.phase === 'auction' && (GameStore.bidTurn === GameStore.playerName[0]) ? 'none' : 'block',
            transform: ['translateY(250px)', 'translateY(315px)']
          }}
        >
          <PlayerName active={GameStore.tablePlayers.south.active}>{GameStore.tablePlayers.south.name}</PlayerName>
          </Box>

        {/* West position */}
        <Box
          sx={{
            position: 'absolute',
            left: GameStore.dummyAbsolute === 'west' ? [130, 100] : [65, 100],
            top: '50%',
            mt: [-13, -13],
            transform: ['translateX(-127px) rotate(90deg)', 'translateX(-150px) rotate(90deg)'],
            display: GameStore.phase === 'auction' && (GameStore.bidTurn === GameStore.playerName[0]) ? 'none' : 'block'
          }}
        >
          <PlayerName active={GameStore.tablePlayers.west.active}>{GameStore.tablePlayers.west.name}</PlayerName>
        </Box>
    </>)
}
}
export default TableNames
